import { findDefaultFont, fontTypeToFontTypeFormat } from '../internal';
import type { AlineStandardStyleVariant, AlineTextFormats } from '../internal';

// ToDo:  As we add more marks - e.g., things like padding for vertical spacing - we need to revisit this plugins to make sure each font style has all the appropriate default styles.  For instance, Heading 1 should have a top padding and subtitle a lighter font color.  Ticket - https://arity.atlassian.net/browse/AR-439.

/** Default font-family. */
const defaultMarks: Required<AlineTextFormats> = {
  bold: { active: false, origin: 'INHERITED' },
  fontColor: {
    color: 'rgb(0,0,0)',
    origin: 'INHERITED',
  },
  fontSize: {
    origin: 'INHERITED',
    size: 12,
  },
  fontType: fontTypeToFontTypeFormat(findDefaultFont(), 'INHERITED'),
  highlight: {
    color: null,
    origin: 'INHERITED',
  },
  italic: { active: false, origin: 'INHERITED' },
  smallCaps: { active: false, origin: 'INHERITED' },
  strikethrough: { active: false, origin: 'INHERITED' },
  underline: { active: false, origin: 'INHERITED' },
  verticalAlign: { align: 'baseline', origin: 'INHERITED' },
};

export const Marks = {
  default: defaultMarks,
  heading1: {
    ...defaultMarks,
    bold: {
      active: true,
      origin: 'INHERITED',
    },
    fontSize: {
      origin: 'INHERITED',
      size: 20,
    },
  },
  heading2: {
    ...defaultMarks,
    bold: {
      active: true,
      origin: 'INHERITED',
    },
    fontSize: {
      origin: 'INHERITED',
      size: 16,
    },
  },
  heading3: {
    ...defaultMarks,
    bold: {
      active: true,
      origin: 'INHERITED',
    },
    fontSize: {
      origin: 'INHERITED',
      size: 14,
    },
  },
  subtitle: {
    ...defaultMarks,
    bold: {
      active: true,
      origin: 'INHERITED',
    },
    fontSize: {
      origin: 'INHERITED',
      size: 15,
    },
  },
  title: {
    ...defaultMarks,
    bold: {
      active: true,
      origin: 'INHERITED',
    },
    fontSize: {
      origin: 'INHERITED',
      size: 26,
    },
  },
} as const satisfies Record<string, AlineTextFormats>;

export const defaultStyles = {
  'style-heading1': {
    fontStyle: 'Heading 1',
    styleVariant: 'style-heading1',
    styles: Marks.heading1,
  },
  'style-heading2': {
    fontStyle: 'Heading 2',
    styleVariant: 'style-heading2',
    styles: Marks.heading2,
  },
  'style-heading3': {
    fontStyle: 'Heading 3',
    styleVariant: 'style-heading3',
    styles: Marks.heading3,
  },
  'style-normal': {
    fontStyle: 'Normal',
    styleVariant: 'style-normal',
    // We initialize styles to the default at first and then change.
    styles: Marks.default,
  },
  'style-subtitle': {
    fontStyle: 'Subtitle',
    styleVariant: 'style-subtitle',
    styles: Marks.subtitle,
  },
  'style-title': {
    fontStyle: 'Title',
    styleVariant: 'style-title',
    styles: Marks.title,
  },
};

export const defaultStyleVariant: AlineStandardStyleVariant = 'style-normal';
export const defaultStyle = defaultStyles[defaultStyleVariant];
